/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_ChangesInputs */

const en_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview Changes`)
};

const fr_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu des modifications`)
};

const de_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen in der Vorschau`)
};

const it_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima delle modifiche`)
};

const ru_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр изменений`)
};

const es_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de cambios`)
};

const zh_cn2_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览更改`)
};

const ja_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更のプレビュー`)
};

const hi_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों का पूर्वावलोकन करें`)
};

const pt_pt2_preview_changes = /** @type {(inputs: Preview_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização das alterações`)
};

/**
* | output |
* | --- |
* | "Preview Changes" |
*
* @param {Preview_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preview_changes = /** @type {((inputs?: Preview_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preview_changes(inputs)
	if (locale === "de") return de_preview_changes(inputs)
	if (locale === "it") return it_preview_changes(inputs)
	if (locale === "ru") return ru_preview_changes(inputs)
	if (locale === "es") return es_preview_changes(inputs)
	if (locale === "zh-CN") return zh_cn2_preview_changes(inputs)
	if (locale === "ja") return ja_preview_changes(inputs)
	if (locale === "hi") return hi_preview_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_preview_changes(inputs)
	return en_preview_changes(inputs)
});